import { useState } from "react";
import { NameCard } from "./NameCard";
import "../../Ambition/OurCompany/index.css";
import "./index.css";
import { updateEffort } from "../../../apis/Business/DepartmentEffortApi";
import { useInvalidateQuery } from "../../../components/InvalidateQueryContext";
import { useUserAccess } from "../../../components/WriteAccessContext";

export const WriteEffort = ({
  effortName,
  question,
  effortId,
  departmentId,
  description,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [text, setText] = useState("");
  const { triggerInvalidate } = useInvalidateQuery();
  const { userAccess } = useUserAccess();

  const handleUpdateDepartment = async () => {
    if (
      (editedName.trim() && editedName.trim() !== question) ||
      (text.trim() && text.trim() !== description)
    ) {
      try {
        const updatedEffort = await updateEffort(
          departmentId,
          effortId,
          triggerInvalidate,
          editedName ? editedName : question,
          text ? text : description ? description : null
        );

        setIsEditingName(false);
        setIsEditing(false);
      } catch (error) {
        console.error("Failed to update department:", error);
      }
    } else {
      setIsEditingName(false);
      setIsEditing(false);
    }
  };

  const handleBlur = () => {
    handleUpdateDepartment();
  };
  return (
    <div style={{ display: "flex", gap: "28px" }}>
      <NameCard
        deptName={effortName}
        isBottom={true}
        className={"write-effort-container"}
      />
      <div className="ambition__ourcompany__writeinbox__wrapper">
        <div className="ambition__ourcompany__writeinbox p-5 pt-4">
          <div className="mb-3">
            {isEditingName && userAccess === "write" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="text"
                  value={editedName}
                  onChange={(e) => setEditedName(e.target.value)}
                  onBlur={handleUpdateDepartment}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleUpdateDepartment();
                    }
                  }}
                  autoFocus
                  style={{
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    color: "white",
                    fontSize: "inherit",
                    width: "100%",
                  }}
                />
              </div>
            ) : (
              <div
                onClick={() => setIsEditingName(true)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "33px",
                  fontSize: "1.2rem",
                }}
              >
                <h5> {question}</h5>
              </div>
            )}
          </div>
          <div
            className="min-h-[100px] border rounded p-2"
            onClick={() => setIsEditing(true)}
          >
            {isEditing && userAccess === "write" ? (
              <textarea
                className="w-full h-full effort-area"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={handleBlur}
                autoFocus
                style={{
                  border: "none",
                  background: "none",
                  resize: "none",
                  width: "100%",
                }}
              />
            ) : (
              <div className="w-full h-full">
                {description || "Type in description of Effort here"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
